import { isAndroid, isWeb } from 'src/shared';
import { IAnyStrObject, IFunStrObject } from 'src/types';

// subscribe handlers
const handlers: IFunStrObject = {};
const eventPrefix = 'ma_custom_event_';

/**
 * subscribe web event(user)
 */
export function webSubscribe(eventName: string, handler: Function) {
  handlers[eventName] = handler;
}

/**
 * subscribe custom event
 */
export function subscribe(eventName: string, handler: Function) {
  handlers[`${eventPrefix}${eventName}`] = handler;
}

/**
 * trigger event handler
 */
export function subscribeHandler(eventName: string, data: IAnyStrObject) {
  const handler = handlers[eventName];
  return handler(data);
}

export function publish(eventName: string, params: IAnyStrObject = {}) {
  const paramsString = JSON.stringify(params);
  publishHandler(`${eventPrefix}${eventName}`, paramsString);
}

export function webPublish(eventName: string, params: IAnyStrObject = {}) {
  const paramsString = JSON.stringify(params);
  publishHandler(eventName, paramsString);
}

/**
 * 通知 Native, 处理业务事件
 */
function publishHandler(eventName: string, paramsString: string) {
  if (isWeb) {
    window.simulatorWebkit.messageHandlers.notifyNative.postMessage({
      eventName,
      paramsString,
      type: 'legacy'
    });
  } else if (isAndroid) {
    window.viewLayerNative.notifyNative(eventName, paramsString);
  } else {
    window.webkit.messageHandlers.notifyNative.postMessage({
      eventName,
      paramsString
    });
  }
}
